<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 text-primary"><i class="fas fa-clipboard-check text-primary"></i> Appointment</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Appointment With<sup><span class="text-danger font-12">*</span></sup>
            :</label>
        <input type="text" class="form-control form-control-sm" v-model="Obj.ApptWith" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Appointment Setter<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.ApptSetter" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Slot<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="datetime-local" class="form-control form-control-sm rounded cursor-pointer" role="button" v-model="Obj.Slot" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Mobile No<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="number" class="form-control form-control-sm"  @input="limitDigits($event, 10, v => Obj.Mobile = v)" v-model="Obj.Mobile" />
        </div>
      </div>
      <div class="col-md-12 text-end mt-2">
        <button class="btn btn-sm btn-darknavy me-1" @click="save()">
          <i class="fa fa-save"></i> Save
        </button>
         <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
           <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
         <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />

        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.ApptWith" @delRecord="delRecord" @closeModal="delObj.ApptWith = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( { ApptWith: "", ApptSetter: "", Slot: new Date().toISOString().slice(0, 19), Mobile: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Appointment With', key: 'ApptWith'},
  { label: 'Appointment Setter', key: 'ApptSetter' },
   { label: 'Slot', key: 'Date' },
  { label: 'Mobile', key: 'Mobile' }
]);
const handleEdit = (row) => {
    Obj.value = { ...row, Slot: row.Slot ? row.Slot.slice(0, 19) : new Date().toISOString().slice(0, 19) }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
  const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
 const formatDateTime= (dateInput) => {
      const date = new Date(dateInput);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); 
      const year = date.getFullYear();
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    }
  const  save =async() =>{
      const fields = {
        AppointmentWith: { value: Obj.value.ApptWith, validators: [isRequired], },
        AppointmentSetter: { value: Obj.value.ApptSetter, validators: [isRequired], },
        Slot: { value: Obj.value.Slot, validators: [isRequired], },
        MobileNo: { value: Obj.value.Mobile, validators: [ (v) => { if (!v) return "Mobile No. is required"; if (v.length < 10) return "Mobile No. must be 10 digits"; return null; }, ], },
      };
      errors.value = validateForm(fields);
      const idx = rows.value.findIndex(item => item.Slot === Obj.value.Slot && item._id !== Obj.value._id);
      if (idx >= 0) {
        msgObj.value = { msg: "Slot already exists.", role: "danger", show: true, };
        return ;
      }
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/Appointment${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Appointment ${msg} Successfuly`, role: "success", show: true, };
          })
          .catch((error) => { console.log(error); });
      }
    }
   const reset =async () => {
      Obj.value = { ApptWith: "", ApptSetter: "", Slot: new Date().toISOString().slice(0, 19), Mobile: "", };
      msgObj.value = { msg: "", role: "", show: false };
      errors.value={};
    }
      const progress = ref(0)
    const loadData =async () =>  {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Appointment/all') .then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1,Date: formatDateTime(item.Slot) }));
      progress.value = 0
      clearInterval(progressInterval)
    });
    }
    const delRecord =async () =>  {
      await api.delete(`/Appointment/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Appointment Deleted Successfuly.", role: "danger", show: true, };
        });
    }
onMounted(() => { loadData() })
</script>